
import DataImport from "@common/src/components/scope/data-import/index.vue";
import { Component, Vue } from "vue-property-decorator";
import { Table } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const marketing = namespace("marketing");
const app = namespace("app");
@Component({
  components: { DataImport }
})
@Table.DataImport({
  templateUrl: "",
  actionUrl: "/filecloud/importSetCard"
})
export default class ServiceList extends Vue {
  @marketing.Action queryCardTemplateList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  t = t;
  showSelectTemplate: boolean = false;
  cardTemplateList = [];
  formData: any = {};
  urlPormise: any;
  handleGetTemplateUrl() {
    this.showSelectTemplate = true;
    this.urlPormise = new Promise(this.promiseHandler);
    return this.urlPormise;
  }
  resolver: any;
  promiseHandler(resolve) {
    this.resolver = resolve;
  }
  getCardTemplateList(cardType = 1) {
    this.queryCardTemplateList({
      pageNum: 1,
      pageSize: 999,
      status: 1,
      cardType: cardType
    }).then(data => {
      this.cardTemplateList = data.data.list;
    });
  }
  created() {
    this.init();
  }
  init() {
    this.getCardTemplateList();
  }
  handleConfirmTemplate() {
    if (!this.formData.cardTemplateCode) {
      return this.$message.error(t("v260.please-select-package-template"));
    }
    this.btnStartLoading();
    setTimeout(() => {
      formDownload(`${window.API_URL}/card/downloadImportSetCardTemplate`, {
        cardTemplateCode: this.formData.cardTemplateCode
      });
      this.btnStopLoading();
      this.resolver();
      this.showSelectTemplate = false;
    }, 1000);
  }
}
